import { render, staticRenderFns } from "./AppReleasesTab.vue?vue&type=template&id=1114c30b&scoped=true"
import script from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppReleasesTab.vue?vue&type=style&index=0&id=1114c30b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1114c30b",
  null
  
)

export default component.exports